import * as React from "react";
import helpers from "../../helpers/common";
import projects from "../../models/projects";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import ProjectForm from "./ProjectForm";

export default function ProjectEditMain ({project, refresh}) {
    const [fields, setFields] = useState({})
    const [errors, setErrors] = useState({})
    const {setShowLoader, notify, defaultCurrency, userData} = useRootHook()
    
    // Только админ и супер админ могут редактировать
    const canEdit = userData?.role === helpers.roles.A || userData?.role === helpers.roles.S

    useEffect(() => {
        if (!project) return

        setFields({
            id: project.id,
            name: project.name,
            email: project.email,
            url: project.url,
            phone: project.phone,
            enabled: project.enabled,
            fee_global_pct: project.fee_global_pct ?? '',
            pm_hold_days: project.pm_hold_days ?? 0,
            pm_hold_amount: project.pm_hold_amount ?? 0,
            pm_reserve_days: project.pm_reserve_days ?? 0,
            pm_reserve_amount: project.pm_reserve_amount ?? 0,
            pm_dispute_cost: defaultCurrency?.subunit ? ((project.pm_dispute_cost || 0) / defaultCurrency.subunit) : (project.pm_dispute_cost || 0),
        })
    }, [project, defaultCurrency?.subunit])

    if (!project) return null

    const handleChange = (ev) => {
        if (!canEdit) return // Блокируем изменения для мерчантов
        
        const [target, value, name] = helpers.getFormEventData(ev)

        setErrors({...errors, [name]: undefined})

        setFields((prevState) => {
            let newFields = {...prevState}
            newFields[name] = value

            return newFields
        })
    }

    const handleBlur = (ev) => {
        if (!canEdit) return // Блокируем валидацию для мерчантов
        
        const [target, value, name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof projects.fieldValidator[name] === 'function'
        && projects.fieldValidator[name](newFields, newErrors)

        setFields(newFields)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        if (!canEdit) {
            notify('Only admins can edit projects', 3000)
            return
        }
        
        const validationErrors = projects.methodValidator.edit(fields)
        setErrors(validationErrors)
        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        projects.edit(fields)
            .then(() => {
                setShowLoader(false)
                notify('Project updated')
                refresh()
            }).catch(() => setShowLoader(false))
    }

    return <ProjectForm project={project} fields={fields} errors={errors} handleSubmit={handleSubmit} handleChange={handleChange} handleBlur={handleBlur} readOnly={!canEdit}/>
}
